import '../src/index.css';

import type { AppProps } from 'next/app';
import React, { ReactNode } from 'react';

export const StyleProvider = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {/* eslint-disable-next-line react/no-unknown-property */}
      <style jsx global>{`
        :root {
          --primary-color: #007bff;
          --secondary-color: #6c757d;
        }
      `}</style>
      {children}
    </>
  );
};

// Regular App component
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function App({ Component, pageProps }: AppProps) {
  return <Component {...pageProps} />;
}

export default StyleProvider;
